import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { DropDownComponent, DropDownComponentProps, OnDropDownChange } from "../DropDownComponent";
import { TemplateFieldBase } from "../../Areas/Admin/Measures/TemplateEdit/Models/TemplateFieldBase";
import { Template } from "../../Areas/Admin/Measures/TemplateEdit/Models/Template";
import { app } from "../../Frame/App";
import { IDropdownProps, IDropdown } from "../Interfaces/IDropdown";
import { IFieldEdit } from "../../Areas/Admin/Shared/Models/IFieldEdit";
import { ITreeItem } from "../../Controls/Dynamic/ITreeItem";
import { TemplateFieldTypes } from "../../Areas/Admin/Shared/Models/TemplateFieldTypes";
import { TemplateCategoryField } from "../../Areas/Admin/Measures/TemplateEdit/Models/TemplateCategoryField";
import { ITemplateFieldListItem } from "../../Model/IListItem";
import { ITreeField } from "../../Frame/GridViewSelect/ITreeField";

export class FieldModel {
    field: TemplateFieldBase | ITreeField
    name: string;
    value: string;
    children: FieldModel[];
    categoryId: number;
}


export class FieldDropdownComponentProps implements IDropdownProps {
    fields?: IFieldEdit[];
    template?: Template;
    parentContent?: any[];
    addEmptyItem?: boolean;
    includeSubCategories?: boolean = false;
    includeTMassnahmeFields?: boolean = false;
    /** The model where the dropdown value is saved. */
    model?: any;
    name?: string;
    infoText?: string;

    /** The model field where the dropdown value is saved. */
    field?: string;

    /** change event. To set focus to another element in the handler, use window.setTimeout. */
    onChange?: OnDropDownChange;

    createFormGroup?: boolean;

    useGuid?: boolean;

    templateFieldTypes?: TemplateFieldTypes[];
    checkSubmeasureTypes?: boolean;
    dataFromSubmeasureList?: ITemplateFieldListItem[];
}

export class FieldDropdownComponent extends JSXComponent implements IDropdown {
    props: FieldDropdownComponentProps;
    constructor(props: FieldDropdownComponentProps) {
        super(props);
    }

    items: FieldModel[];
    dropdownRef: DropDownComponent;
    hasBlocks: boolean = false;
    listCategoryWithSubCategories: ITreeItem;
    // Model creation
    createItemsFromTemplate = () => {
        //init list of categories that contains subCategories
        this.InitialListCategoryWithSubCategories(this.props.template.id);

        // Create Allgemein block
        let allgemein = this.createFieldModel(null, "Allgemein", "0");
        this.addFieldChildren(allgemein, 0);
        this.items.push(allgemein);
        for (let block of this.props.template.blocks.items.sort((a, b) => (a.pos > b.pos) ? 1 : -1)) {
            let item = this.createFieldModel(null, block.nameInLanguage, block.id.toString());
            this.addFieldChildren(item, block.id);

            if (item.children.length > 0) {
                this.items.push(item);
            }
        }

        if (this.props.includeTMassnahmeFields) {
            let tmassnahmeItem = this.createFieldModel(null, Resources.TemplateEditClient.tmassnahmeFields, "");
            this.items.push(tmassnahmeItem);

            for (let tmassnahmeField of this.props.template.tmassnahmeFields) {
                let item = new FieldModel();
                item.field = tmassnahmeField;
                item.value = tmassnahmeField.fieldName;
                item.name = tmassnahmeField.name;
                tmassnahmeItem.children.push(item);
            }
        }
    }

    addEventListener = (listener: OnDropDownChange) => {
        this.dropdownRef.addEventListener(listener);
    }

    addFieldChildren = (parent: FieldModel, templateBlockId: number) => {
        this.props.template.fields.items.filter(f => f.templateBlockId == templateBlockId)
            .sort((a, b) => (a.pos > b.pos) ? 1 : -1)
            .forEach((f) => {
                if (!this.props.templateFieldTypes || this.props.templateFieldTypes.includes(f.type) || this.hasSubmeasureFieldType(f)) {
                    if (this.props.includeSubCategories == true && f.type == TemplateFieldTypes.Category) {

                        let categoryField = f as TemplateCategoryField;
                        //check if the category has subcategories

                        let listAllCategories = this.setSubCategoriesAsFieldModel(f, categoryField.categoryId);
                        if (listAllCategories && listAllCategories.length > 0) {
                            parent.children.push.apply(parent.children, listAllCategories);
                        }
                        else {
                            parent.children.push(this.createFieldModel(f, f.getName(), this.getValueFromField(f), f["categoryId"]));
                        }

                    }
                    else {
                        parent.children.push(this.createFieldModel(f, f.getName(), this.getValueFromField(f)));
                    }
                }
            });

    }

    private hasSubmeasureFieldType = (f: TemplateFieldBase): boolean => {
        if (this.props.checkSubmeasureTypes &&
            this.props.dataFromSubmeasureList &&
            this.props.dataFromSubmeasureList.length > 0 &&
            f.type == TemplateFieldTypes.DataFromSubmeasures) {
            return this.props.dataFromSubmeasureList.filter(item => item.parentGuid == f.guid
                && this.props.templateFieldTypes.includes(item.templateFieldType)).length > 0;
        }

        return false;
    }

    getValueFromField = (model: any) => {
        if (this.props.useGuid || this.props.includeSubCategories) {
            return model["guid"];
        } else {
            // use id property
            return model["id"];
        }
    }

    createFieldModel = (item: any, name: string, value: string, categoryId?: number): FieldModel => {
        let model = new FieldModel();

        model.field = item;
        model.name = name;
        model.value = value;
        model.children = [];
        model.categoryId = categoryId;

        return model;
    }

    createItemsFromFields = () => {
        for (let field of this.props.fields) {
            if (this.props.includeSubCategories == true) {
                if (field.type == TemplateFieldTypes.Category) {
                    //init list of categories that contains subCategories
                    this.InitialListCategoryWithSubCategories(this.props.template.id);

                    this.items.push(this.createFieldModel(field, field.getName(), this.getValueFromField(field), field["categoryId"]));
                    //check if he has sub elements

                    let listAllCategories = this.setSubCategoriesAsFieldModel(field, (field as TemplateCategoryField).categoryId);
                    if (listAllCategories && listAllCategories.length > 0) {

                        this.items.push.apply(this.items, listAllCategories);
                    }
                }
                else {
                    this.items.push(this.createFieldModel(field, field.getName(), this.getValueFromField(field)));
                }
            }
            else {
                this.items.push(this.createFieldModel(field, field.getName(), this.getValueFromField(field)));
            }
        }
    }
    createItemsParentContent = () => {
        for (let field of this.props.parentContent) {
            let parent = this.createFieldModel(field, field.name, field.fieldId);
            this.items.push(parent);

            field.children.forEach(f => {
                let fieldIdentifier: string;
                if (f.uniqueId) {
                    fieldIdentifier = f.uniqueId;
                } else {
                    fieldIdentifier = f.fieldId.toString()
                }
                parent.children.push(this.createFieldModel(f, f.name, fieldIdentifier));
            });
        }
    }

    // End Model Creation

    getSelectedItem = (): any => {
        return this.dropdownRef.getSelectedItem();
    }

    setValue = (value: string, triggerOnChange: boolean = true): void => {
        this.dropdownRef.setValue(value, triggerOnChange);
    }

    handleChange = (control: DropDownComponent) => {
        if (this.props.model) {
            this.updateModelFromControl(this.dropdownRef);
        }
        if (this.props.onChange) {
            this.props.onChange(this.dropdownRef);
        }
    }

    element: HTMLElement;
    getElement = () => {
        this.items = [];
        if (this.props.fields) {
            this.createItemsFromFields();
        }
        else if (this.props.parentContent) {
            this.createItemsParentContent();
        }
        else {
            if (!this.props.template) {
                throw new Error("Either a colleciton of fields or a template object must be provided for the FieldDropdown control.");
            }
            this.createItemsFromTemplate();
        }

        let dropdownProps: DropDownComponentProps = {
            displayProperty: "name",
            valueProperty: "value",
            id: app.createRadomizedLetters(10),
            childrenProperty: "children",
            items: this.items,
            onChange: this.handleChange,
            expandAll: false,
            disableSort: true,
            addEmptyItem: true,
            infoText: this.props.infoText
        }

        this.dropdownRef = new DropDownComponent(dropdownProps);

        this.element = <div className={"field-dropdown" + (!(this.props.createFormGroup === false) ? " form-group" : "")}>
            {this.props.name
                ? <label className="form-label">{this.props.name}</label>
                : []}
            {this.dropdownRef.render()}
        </div>
    }

    private updateModelFromControl = (control: DropDownComponent) => {
        let selectedItem = control.getSelectedItem();
        this.props.model.setPropertyByPath(this.props.field, selectedItem.value);
    }

    render(): HTMLElement {
        this.getElement();

        if (this.props.model && this.props.field && this.props.model[this.props.field]) {
            this.dropdownRef.setValue(this.props.model[this.props.field].toString(), false);
        }

        return this.element;
    }
    InitialListCategoryWithSubCategories = (templateId: number) => {

        $.ajax({
            url: app.resolveUrl(`~/api/category/getCascadingCategoriesByTemplateId/${templateId}`),
            method: "GET",
            async: false,
            success: (result: any) => {
                this.listCategoryWithSubCategories = result;
            },
            error: (err) => {
                console.log(err);
            }
        });
    }

    setSubCategoriesAsFieldModel = (field: any, categoryId: number): FieldModel[] => {
        let result: FieldModel[] = [];
        let listSubCategories: ITreeItem[] = [];

        let list = this.listCategoryWithSubCategories.children.filter(f => f.categoryId == categoryId.toString());
        if (list.length > 0) {
            listSubCategories = this.loopRecursiveListCategories(list);
            if (listSubCategories && listSubCategories.length > 0) {
                listSubCategories.forEach((f) => {
                    let model;
                    model = this.createFieldModel(field, f.text, field.guid + "_" + f.categoryId, Number(f.categoryId));

                    result.push(model);
                });
            }
        }

        return result
    }

    loopRecursiveListCategories = (listItems: ITreeItem[]): ITreeItem[] => {
        let result: ITreeItem[] = [];
        for (let i = 0; i < listItems.length; i++) {
            result.push(listItems[i]);
            var listChild = this.listCategoryWithSubCategories.children.filter(p => p.parentCategoryId == listItems[i].id);
            if (listChild.length > 0) {
                listItems.push.apply(listItems, listChild);
            }
        }
        return result;
    }
}
